const EXTENSION_CONTENT_TYPES = {
	pdf: 'application/pdf',
	jpg: 'image/jpeg',
	jpeg: 'image/jpeg',
	png: 'image/png',
	gif: 'image/gif',
	webp: 'image/webp'
}

const fileExtension = file => (file?.name || '').split('.').pop().toLowerCase()

export const isPdfFile = file =>
	file?.type === 'application/pdf' ||
	(file?.type === '' && fileExtension(file) === 'pdf')

export const resolveFileContentType = file => {
	if (file?.type) {
		return file.type
	}

	return EXTENSION_CONTENT_TYPES[fileExtension(file)] || ''
}
